// Trilogy Sports & Fitness Outreach vocabularies (PROMPT 11)
import { COUNTRIES } from "@/config/partnerOptions";

export { COUNTRIES };

export const EVENT_TYPES = [
  { value: "senior_home", label: "Senior home" },
  { value: "old_age_home", label: "Old age home" },
  { value: "retirement_community", label: "Retirement community" },
  { value: "assisted_living", label: "Assisted living" },
  { value: "church", label: "Church" },
  { value: "community_group", label: "Community group" },
  { value: "fitness_demo", label: "Fitness demo / class" },
  { value: "health_fair", label: "Health fair" },
  { value: "other", label: "Other" },
];

export const TRILOGY_PIPELINE = [
  { value: "facility_lead", label: "Facility lead", tone: "khaki" },
  { value: "contacted", label: "Contacted", tone: "sky" },
  { value: "demo_proposed", label: "Fitness demo proposed", tone: "sky" },
  { value: "event_booked", label: "Event booked", tone: "navy" },
  { value: "event_completed", label: "Event completed", tone: "navy" },
  { value: "leads_captured", label: "Leads captured", tone: "amber" },
  { value: "consultations_booked", label: "Consultations booked", tone: "amber" },
  { value: "mmm_cases_created", label: "MMM cases created", tone: "green" },
  { value: "recurring", label: "Recurring relationship", tone: "green" },
  { value: "revenue_opportunity", label: "Revenue opportunity created", tone: "green" },
];

export const RELATIONSHIP_STATUSES = [
  { value: "new", label: "New", tone: "khaki" },
  { value: "warm", label: "Warm", tone: "amber" },
  { value: "active", label: "Active", tone: "navy" },
  { value: "recurring", label: "Recurring", tone: "green" },
  { value: "dormant", label: "Dormant", tone: "gray" },
];

export const TONE = {
  red: { bg: "rgba(156,30,34,0.10)", color: "#9C1E22", border: "rgba(156,30,34,0.24)" },
  amber: { bg: "rgba(183,121,31,0.14)", color: "#9A6516", border: "rgba(183,121,31,0.30)" },
  sky: { bg: "rgba(155,185,206,0.25)", color: "#1C4358", border: "rgba(155,185,206,0.45)" },
  navy: { bg: "rgba(28,67,88,0.10)", color: "#1C4358", border: "rgba(28,67,88,0.20)" },
  green: { bg: "rgba(47,125,90,0.12)", color: "#256B4B", border: "rgba(47,125,90,0.28)" },
  khaki: { bg: "rgba(196,200,155,0.35)", color: "#5A5E2E", border: "rgba(196,200,155,0.60)" },
  gray: { bg: "rgba(75,85,99,0.10)", color: "#4B5563", border: "rgba(75,85,99,0.22)" },
};

const prettify = (v) => (v ? String(v).replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "");
export const optOf = (arr, val) => arr.find((o) => o.value === val) || null;
export const labelOf = (arr, val) => optOf(arr, val)?.label || prettify(val);
export const toneOf = (arr, val) => TONE[optOf(arr, val)?.tone || "gray"];
